import { Deferred, Effect, Layer, Scope } from "effect";
import { resourceTabFocusFailure } from "./resource-focus-model.ts";
import { ResourceTabFocusIo } from "./resource-focus-service.ts";

export const ResourceTabFocusIoLive = Layer.succeed(ResourceTabFocusIo, {
  frame: Effect.scoped(Effect.gen(function* () {
    const tick = yield* Deferred.make<void>();
    yield* Effect.acquireRelease(
      Effect.try({ try: () => requestAnimationFrame(() => { Deferred.doneUnsafe(tick, Effect.void); }), catch: resourceTabFocusFailure }),
      id => Effect.try({ try: () => cancelAnimationFrame(id), catch: resourceTabFocusFailure }).pipe(Effect.orDie)
    );
    yield* Deferred.await(tick);
  })).pipe(Effect.provideService(Scope.PreserveFinalizerFailures, true)),
  focus: (target, kind) => Effect.try({ try: () => {
    if (!target.isConnected) return;
    const button = [...target.querySelectorAll<HTMLElement>("[id]")].find(node => node.id === `resource-tab-${kind}`);
    button?.focus();
  }, catch: resourceTabFocusFailure })
});
